<template>
  <b-card content-class="mt-8">
    <b-tabs
      content-class="mt-3"
      :vertical="window.width >= 620 ? false : true"
      nav-wrapper-class="w-100"
    >
      <b-tab title="جزییات درخواست" active>
        <b-row>
          <b-col cols="12" md="9" sm="12">
            <b-row>
              <b-col cols="12" sm="6" md="4">
                <b-form-group label="نام درخواست دهنده:">
                  <div class="form-control">
                    {{
                      sharingDetail.gateway
                        ? sharingDetail.gateway.user.name
                        : ""
                    }}
                  </div>
                </b-form-group>
              </b-col>
              <b-col cols="12" sm="6" md="4">
                <b-form-group label="تاریخ ثبت:">
                  <div class="form-control">
                    {{
                      sharingDetail.created_at | moment("jYYYY-jM-jD HH:mm:ss")
                    }}
                  </div>
                </b-form-group>
              </b-col>
              <b-col cols="12" sm="6" md="4">
                <b-form-group label="تاریخ ارسال به بانک:">
                  <div class="form-control">
                    {{
                      sharingDetail.child_document == null
                        ? "انجام نشده"
                        : sharingDetail.child_document.date
                          | moment("jYYYY-jM-jD HH:mm:ss")
                    }}
                  </div>
                </b-form-group>
              </b-col>
              <b-col cols="12" sm="6" md="4">
                <b-form-group label="وب سایت:">
                  <div class="form-control">
                    {{
                      sharingDetail.gateway
                        ? sharingDetail.gateway.website_name
                        : ""
                    }}
                  </div>
                </b-form-group>
              </b-col>
              <b-col cols="12" sm="6" md="4">
                <b-form-group label="کد پذیرنده:">
                  <div class="form-control">
                    {{
                      sharingDetail.gateway
                        ? sharingDetail.gateway.acceptor_code
                        : ""
                    }}
                  </div>
                </b-form-group>
              </b-col>
              <b-col cols="12" sm="6" md="4">
                <b-form-group label="مبلغ:">
                  <div class="form-control">
                    {{
                      sharingDetail.bes != null
                        ? sharingDetail.bes.toLocaleString()
                        : 0
                    }}
                    ریال
                  </div>
                </b-form-group>
              </b-col>
              <b-col cols="12" sm="6" md="4">
                <b-form-group label="نام صاحب حساب مقصد:">
                  <div class="form-control">
                    {{
                      sharingDetail.detail
                        ? sharingDetail.detail.user_card.nickname
                        : null
                    }}
                  </div>
                </b-form-group>
              </b-col>
              <b-col cols="12" sm="6" md="4">
                <b-form-group label="شماره شبا مقصد:">
                  <div class="form-control">
                    {{
                      sharingDetail.detail
                        ? sharingDetail.detail.user_card.shaba_number
                        : null
                    }}
                  </div>
                </b-form-group>
              </b-col>
              <b-col cols="12" sm="6" md="4">
                <b-form-group label="بانک مقصد:">
                  <div class="form-control">
                    {{
                      sharingDetail.detail
                        ? sharingDetail.detail.user_card.bank_name.title
                        : null
                    }}
                  </div>
                </b-form-group>
              </b-col>

              <b-col cols="12" sm="6" md="4">
                <b-form-group label="وضعیت تراکنش:">
                  <div class="form-control">
                    {{
                      sharingDetail.child_document
                        ? "انجام شده"
                        : sharingDetail.parent_id == -1
                        ? "لغو شده"
                        : "انجام نشده"
                    }}
                  </div>
                </b-form-group>
              </b-col>
              <b-col cols="12" sm="6" md="4">
                <b-form-group label="شماره شبا مبدا:">
                  <div class="form-control">
                    {{
                      sharingDetail.child_document
                        ? sharingDetail.child_document.doc_details[0].detail
                            .user_card.shaba_number
                        : null
                    }}
                  </div>
                </b-form-group>
              </b-col>

              <b-col cols="12" sm="6" md="4">
                <b-form-group label="بانک مبدا:">
                  <div class="form-control">
                    {{
                      sharingDetail.child_document
                        ? sharingDetail.child_document.doc_details[0].detail
                            .user_card.bank_name.title
                        : null
                    }}
                  </div>
                </b-form-group>
              </b-col>
              <b-col cols="12" sm="6" md="4">
                <b-form-group label="کد رهگیری تراکنش:">
                  <div class="form-control">
                    {{
                      sharingDetail.child_document
                        ? sharingDetail.child_document.doc_details[0]
                            .tracking_number
                        : null
                    }}
                  </div>
                </b-form-group>
              </b-col>
              <b-col cols="12" sm="6" md="4">
                <b-form-group label="کارمزد:">
                  <div class="form-control">{{ wage }} ریال</div>
                </b-form-group>
              </b-col>
              <b-col cols="12" sm="6" md="4">
                <b-form-group label="بابت:">
                  <div class="form-control">
                    {{ sharingDetail.babat }}
                  </div>
                </b-form-group>
              </b-col>
            </b-row>
          </b-col>

          <b-col cols="12" md="3" sm="12">
            <b-row class="mt-9">
              <b-col cols="12" sm="6" md="12" class="mb-5">
                <b-button
                  block
                  variant="info"
                  @click="getInqiurySheba('Saderat')"
                  :class="
                    isBusySheba ? 'spinner spinner-light spinner-right' : ''
                  "
                  >استعلام شبا</b-button
                >
              </b-col>
              <!--<b-col cols="12" sm="6" md="12" class="mb-5">
                 <b-button
            block
            variant="success"
            @click="sendRequest"
            v-b-modal.modal-1
            :class="
              isBusyTransaction ? 'spinner spinner-light spinner-right' : ''
            "
            >استعلام</b-button
          > 
              </b-col>-->
              <b-col v-if="!showbtn" cols="12" sm="6" md="12" class="mb-5">
                <b-button
                  block
                  variant="success"
                  @click="sendRequest(null)"
                  :class="
                    isBusyTransaction
                      ? 'spinner spinner-light spinner-right'
                      : ''
                  "
                  >ارسال درخواست</b-button
                >
              </b-col>
              <template v-if="!showbtn">
                <b-col
                  class="mb-5"
                  v-for="item in listBank"
                  :key="item.id"
                  cols="12"
                  sm="6"
                  md="12"
                >
                  <b-button
                    block
                    :disabled="disabled"
                    variant="warning"
                    @click="sendRequest(item)"
                    :class="
                      item.isBusyTransaction
                        ? 'spinner spinner-light spinner-right'
                        : ''
                    "
                  >
                    {{ item.fa_title }}
                  </b-button>
                </b-col>
              </template>
              <template v-if="!showbtn">
                <b-col class="mb-5" cols="12" sm="6" md="12">
                  <b-button
                    block
                    :disabled="disabled"
                    variant="danger"
                    @click="$bvModal.show('ChekoutManual')"
                  >
                    انجام دستی بانکی
                  </b-button>
                </b-col>
              </template>
              <b-col v-if="showbtnRefund" cols="12" sm="6" md="12" class="mb-5">
                <b-button
                  block
                  variant="success"
                  @click="refund()"
                  :class="
                    isBusyRefund ? 'spinner spinner-light spinner-right' : ''
                  "
                  >عودت وجه</b-button
                >
              </b-col>
            </b-row>
          </b-col>
        </b-row>
      </b-tab>
      <b-tab title="درخواست های ارسال شده از سامان">
        <b-table
          responsive
          striped
          hover
          :fields="fieldsSaman"
          :items="itemSaman"
          show-empty
          empty-text="آیتمی جهت نمایش وجود ندارد"
        ></b-table>
      </b-tab>
      <b-tab title="درخواست های ارسال شده از صادرات">
        <b-table
          responsive
          striped
          hover
          :fields="fieldsSaderat"
          :items="itemSaderat"
          show-empty
          empty-text="آیتمی جهت نمایش وجود ندارد"
        ></b-table>
      </b-tab>
    </b-tabs>
    <b-modal id="IbanData" title="اطلاعات شبا" hide-footer>
      <b-form-group label="نام صاحب حساب">
        <div class="form-control">
          {{ IbanData.ownerName }}
        </div>
      </b-form-group>
      <b-form-group label="شماره حساب">
        <div class="form-control">
          {{ IbanData.accountNumber }}
        </div>
      </b-form-group>
      <b-form-group label="شماره شبا">
        <div class="form-control">
          {{ IbanData.ibanNumber }}
        </div>
      </b-form-group>
      <b-form-group label="وضعیت حساب">
        <div class="form-control">
          {{ IbanData.accountStatus == "Active" ? "فعال" : "غیر فعال" }}
        </div>
      </b-form-group>
      <b-row>
        <b-col
          ><b-button class="mt-3" variant="primary" block @click="UpdateDetails"
            >بروزرسانی</b-button
          ></b-col
        >
        <b-col
          ><b-button
            class="mt-3"
            variant="danger"
            block
            @click="$bvModal.hide('IbanData')"
            >بستن</b-button
          ></b-col
        >
      </b-row>
    </b-modal>
    <b-modal id="ChekoutManual" title="انجام دستی بانکی" hide-footer>
      <b-form-group label="نام بانک:">
        <b-form-select
          v-model="manualCheckout.selectedBank"
          :options="optionsBank"
        ></b-form-select>
      </b-form-group>
      <b-form-group label="نوع درخواست:">
        <b-form-select
          v-model="manualCheckout.selectedType"
          :options="optionsType"
        ></b-form-select>
      </b-form-group>
      <b-form-group label="کد رهگیری:">
        <b-form-input v-model="manualCheckout.trackingNumber"></b-form-input>
      </b-form-group>
      <b-form-group label="تاریخ انجام:">
        <date-picker
          clearable
          v-model="manualCheckout.created_at"
        ></date-picker>
      </b-form-group>
      <b-row>
        <b-col
          ><b-button
            class="mt-3"
            variant="primary"
            block
            @click="CheckoutManual"
            :class="isBusyManual ? 'spinner spinner-light spinner-right' : ''"
            :disabled="isBusyManual"
            >درخواست انجام دستی بانکی</b-button
          ></b-col
        >
        <b-col
          ><b-button
            class="mt-3"
            variant="danger"
            block
            @click="$bvModal.hide('ChekoutManual')"
            >بستن</b-button
          ></b-col
        >
      </b-row>
    </b-modal>
  </b-card>
</template>

<script>
import httpHelper from "../../../helpers/httpHelper";
import TableShowData from "../../../components/table";
import persianDate from "@/helpers/persianDate";
import { UPDATE_USER_CARD } from "@/core/services/store/updateUserCard.module";
import MDDropdown from "../../../components/MDDropdown";

export default {
  name: "sharingDetails",
  data() {
    return {
      isModalVisible: false,
      window: {
        width: 0,
        height: 0,
      },
      itemSaman: [],
      itemSaderat: [],
      fieldsSaman: [
        {
          key: "created_at",
          label: "تاریخ ارسال",
          formatter: (value, key, item) => {
            return persianDate.getDate(item.created_at);
          },
        },
        {
          key: "version",
          label: "از بانک",
          formatter(value, key, item) {
            if (value == 1) return "سامان 1";
            else return "سامان 2";
          },
        },
        {
          key: "transferStatus",
          label: "وضعیت",
        },
        {
          key: "transactionStatus",
          label: "نتیجه",
        },
        // {
        //   key: "transactions_created_at1",
        //   label: "بانک ارسالی",
        // },
      ],
      fieldsSaderat: [
        {
          key: "website",
          label: "تاریخ ارسال",
        },
        {
          key: "amount",
          label: "از بانک",
        },
        {
          key: "transferStatus",
          label: "وضعیت",
        },
        {
          key: "transactionStatus",
          label: "نتیجه",
        },
      ],
      wage: null,
      listBank: [],
      IbanData: {},
      sharingDetail: {},
      size: "w-25",
      height: "h-50",
      show: false,
      inquiry: { id: this.$route.params.id, api: "" },
      id: this.$route.params.id,
      loadedDetailsSharing: { result: {} },
      loadedDataInquiry: {},
      isBusyTransaction: false,
      isBusySheba: false,
      isBusy: false,
      isBusy2: false,
      modalSheba: "",
      transfer_id: null,
      showbtn: false,
      isBusyRefund: false,
      showbtnRefund: false,
      disabled: false,
      optionsBank: [],
      manualCheckout: {
        selectedBank: null,
        selectedType: null,
        trackingNumber: null,
      },
      optionsType: [
        { value: 0, text: "انتقال حساب به حساب" },
        { value: 1, text: "ساتنا" },
        { value: 2, text: "پایا" },
      ],
      isBusyManual: false,
    };
  },
  components: {
    "list-table": TableShowData,
    MDDropdown,
  },
  computed: {
    // loadedInquiry() {
    //   return Object.assign(
    //     this.loadedDataInquiry,
    //     this.$store.getters.loadedInquiry
    //   );
    // },
  },
  destroyed() {
    window.removeEventListener("resize", this.handleResize);
  },
  created() {
    window.addEventListener("resize", this.handleResize);
    this.handleResize();
  },
  mounted() {
    this.loadedDetailsSharing1();
    this.getBankList();
    // this.getSharing();
  },
  methods: {
    handleResize() {
      this.window.width = window.innerWidth;
      this.window.height = window.innerHeight;
    },
    loadedDetailsSharing1() {
      this.showbtn = true;
      httpHelper.getData("sharing/" + this.$route.params.id).then((res) => {
        res.result.child_document != null
          ? res.result.child_document?.doc_details[0].tracking_number.match(
              "عودت شده"
            )
            ? (this.showbtnRefund = false)
            : (this.showbtnRefund = true)
          : null;
        res.result.child_document != null
          ? (this.showbtn = true)
          : (this.showbtn = false);
        this.sharingDetail = res.result;
        this.itemSaman = [...this.sharingDetail.saman_transaction];
        this.itemSaderat = [...this.sharingDetail.saderat_transaction];
        this.getWage();
      });
    },
    getBankList() {
      httpHelper.getData("sharing/banks").then((res) => {
        let option = {};
        let options = [];
        res.result.forEach((element) => {
          Object.assign(element, { isBusyTransaction: false });
          Object.assign(option, {
            value: element.detail_id,
            text: element.fa_title,
          });
          options.push(option);
          option = {};
        });
        this.listBank = res.result;
        this.optionsBank = options;
      });
    },
    getWage() {
      if (
        this.sharingDetail.doc !== null &&
        this.sharingDetail.child_document !== null
      ) {
        this.wage = "...";
        this.sharingDetail.child_document.doc_details.forEach((element) => {
          if (element.topic_id === 76 && element.bed > 0) {
            this.wage = element.bed.toLocaleString();
          }
        });
      }
    },

    sendRequest(item) {
      this.disabled = true;
      if (item) {
        item.isBusyTransaction = true;
      } else {
        this.isBusyTransaction = true;
      }
      var url = item
        ? "sharing/do_transfer/" + this.$route.params.id + "/" + item.title
        : "sharing/do_transfer/" + this.$route.params.id + "/";
      httpHelper.getData(url).then((res) => {
        if (item) {
          item.isBusyTransaction = false;
        } else {
          this.isBusyTransaction = false;
        }
        if (res.success) {
          this.$makeToast("success", "پرداخت موفق", res.result, 5000);
          this.loadedDetailsSharing1();
        } else {
          this.$makeToast(
            "danger",
            "خطا",
            "پرداخت با مشکل مواجه شد <br/>" + res.error,
            5000
          );
          this.disabled = false;
        }
      });
    },

    close() {
      this.show = false;
    },
    // getSharing() {
    //   let id = this.$route.params.id;
    //   return this.$store.dispatch(GET_DETAILS_SHARING, id);
    // },
    getInqiurySheba(from = "Saderat") {
      this.isBusySheba = true;
      httpHelper
        .getData(
          "sharing/get-iban-info/" +
            from +
            "/" +
            this.sharingDetail.detail.user_card.shaba_number
        )
        .then((res) => {
          this.isBusySheba = false;
          if (res.success == false) {
            if (from == "Saderat") {
              this.getInqiurySheba("Saman");
            } else if (from == "Saman") {
              this.getInqiurySheba("Saman2");
            } else {
              this.$makeToast("danger", "خطا", "مشکل در دریافت اطلاعات", 5000);
            }
          } else {
            this.IbanData = res.result;
            this.$bvModal.show("IbanData");
          }
        });
    },
    UpdateDetails() {
      let obj = {};
      Object.assign(obj, {
        nickname: this.IbanData.ownerName,
        iban: this.IbanData.ibanNumber,
        account_number: this.IbanData.accountNumber,
        request_id: this.$route.params.id,
        api: `user-card/${this.sharingDetail.detail.user_card.id}/update-with-iban`,
      });
      this.$store.dispatch(UPDATE_USER_CARD, obj).then((data) => {
        if (data.success) {
          this.$makeToast(
            "success",
            "بروزرسانی",
            "بروزرسانی با موفقیت انجام گردید.",
            5000
          );
          this.loadedDetailsSharing1();
        } else {
          this.$makeToast(
            "danger",
            "خطا",
            "خطای سمت سرور رخ داده است،لطفا مجددا تلاش نمایید.",
            5000
          );
        }
      });
    },
    refund() {
      this.isBusyRefund = true;
      httpHelper
        .getData(`saverefundedsharings/${this.$route.params.id}`)
        .then((res) => {
          if (res.success) {
            this.$makeToast(
              "success",
              "عودت وجه موفق",
              "عملیات عودت با موفقیت انجام و مبلغ به شارژ حساب کاربر افزوده شد.",
              5000
            );
            this.loadedDetailsSharing1();
          } else {
            this.$makeToast("danger", "خطا", "عودت وجه با مشکل مواجه شد", 5000);
          }
        })
        .catch(() => {
          this.$makeToast(
            "danger",
            "خطا",
            "خطای سمت سرور رخ داده است.لطقا در زمان دیگری اقدام نمایید.",
            5000
          );
        })
        .finally(() => {
          this.isBusyRefund = false;
          this.showbtnRefund = false;
        });
    },
    CheckoutManual() {
      this.isBusyManual = true;
      httpHelper
        .postData(`sharing/save_sattled_fromBank/${this.$route.params.id}`, {
          tracking_number: this.manualCheckout.trackingNumber,
          bank_detailedid: this.manualCheckout.selectedBank,
          requestType: this.manualCheckout.selectedType,
          created_at: this.manualCheckout.created_at,
        })
        .then((res) => {
          this.isBusyManual = false;
          if (res.success == true) {
            this.loadedDetailsSharing1();
            this.$bvModal.hide("ChekoutManual");
            this.$makeToast(
              "success",
              "پرداخت موفق",
              "درخواست انجام دستی بانکی با موفقیت ارسال گردید.",
              5000
            );
          } else {
            this.$makeToast("danger", "خطا", "مشکل در ارسال اطلاعات", 5000);
          }
        });
    },
  },
};
</script>

<style></style>
